import { action } from '@storybook/addon-actions';
import {
  createActions, asyncInitialState, asyncSelectors, dateComparator
} from '../../utils'

import store from '../../../store';

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  reset: () => null,
  asyncs: {
  }
}, 'IESettingsByWarehouse');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    toolPanel: false,
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5,
    selectionOptions: {
      mode: 'single',
      selectFirstRowByDefault: true,
      onSelectionChanged: (selectedRowsData) => {
        store.dispatch(actions.setSelected(selectedRowsData[0] || null));
      }
    }
  },
  Columns: [
    { headerName: 'Warehouse', field: 'Warehouse', minWidth: 100, fixed: true },
    { headerName: 'Max holding', field: 'MaxHolding', minWidth: 100, suppressSorting: true },
    { headerName: 'Reorder point', field: 'ReOrderPoint', minWidth: 120, suppressSorting: true },
    { headerName: 'Safety stock', field: 'SafetyStock', minWidth: 120, suppressSorting: true },
    { headerName: 'Min order quantity', field: 'MinOrderQty', minWidth: 150, suppressSorting: true },
    { headerName: 'Stock cover (days)', field: 'StockCover', minWidth: 150, suppressSorting: true },
    { headerName: 'Future trend %', field: 'FutureTrend', minWidth: 120, suppressSorting: true },
    { headerName: 'Review period (days)', field: 'ReviewPeriod', minWidth: 150, suppressSorting: true },
    { headerName: 'Buy multiples', field: 'BuyMultiples', minWidth: 100, suppressSorting: true },
    { headerName: 'Restrict manual order', field: 'RestrictManualOrderDisplay', minWidth: 150, suppressSorting: true },
  ],
  Data: [],
  summary: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.reset:
      return initialState;
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.reordering.settingsByWarehouse,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.reordering.settingsByWarehouse.fetch_loading,
  gridOptions: state => state.inventoryEnquiry.reordering.settingsByWarehouse.data.gridOptions,
  columns: state => state.inventoryEnquiry.reordering.settingsByWarehouse.data.Columns,
  filterRow: state => state.inventoryEnquiry.reordering.settingsByWarehouse.data.filterRow,
  selectedFilters: state => state.inventoryEnquiry.reordering.settingsByWarehouse.data.selectedFilters,
  selectedRecord: state => state.inventoryEnquiry.reordering.settingsByWarehouse.data.selected,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)